<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$t('chaxunwuliaoxuqiu')" ref="yt" getUrl="/custom/zhengdaxing/erp/material/requirement/getMaterialRequirement" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaobianma')">
            <el-input v-model="yt.conditions.materialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <el-input v-model="yt.conditions.materialName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="filter" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 适配模具名称插槽 -->
      <template #shipeimojumingcheng="scope">
        <el-select filterable :filter-method="(query) => { dataFilter(query, scope.row) }" :style="{ 'width': 200 }" :multiple-limit="1" v-model="scope.row.mould" :multiple="false" :allow-create="false" default-first-option @change="(e) => { mouldChange(e, scope.row) }" size="mini" :reserve-keyword="true">
          <el-option v-for="item in scope.row.items" :key="item.id" :label="item.mould.name" :value="item"></el-option>
        </el-select>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_order_management_production_plan_checkMaterialRequirement_createPlan_zhengdaxing')" type="text" @click="yt.showEditDialog('chuangjianshengchanjihuadan', scope.row, '600px'); setDefaultValue1();">
              {{ $t('chuangjianshengchanjihuadan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'chuangjianshengchanjihuadan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('wuliaobianma/mingcheng')">
              <el-input v-model="yt.editObj.material.code + ' / ' + yt.editObj.material.name" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xuqiuliang') + '/' + $t('weipaichanshuliang')">
              <el-input v-model="yt.editObj.workApplyQty + ' / ' + yt.editObj.unplannedQuantity" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')"></yi_time_input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveValidate();" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet, this.afterGet);
      this.yt.isShowPagination = false;
    }, 300);
  },
  data() {
    return {
      columns: [
        {
          label: 'buchandanhao',
          prop: 'scheNo',
          width: 130
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'xuqiuliang',
          prop: 'workApplyQty',
          width: 80
        },
        {
          label: 'weipaichanshuliang',
          prop: 'unplannedQuantity',
          width: 100
        },
        {
          label: 'shipeimojumingcheng',
          type: 'slot',
          width: 200
        },
        {
          label: 'banzhichanliang',
          prop: 'shiftQuantity',
          width: 130
        },
        {
          label: 'jinjichengdu',
          prop: 'urgencyLevel',
          width: 80
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ],
      items: [],
      filterMoulds: [],
      data: [],
      mould: null,
    }
  },
  methods: {
    beforeGet(params) {
      return params;
    },
    afterGet(result) {
      if (result.data.rows.length > 0) {
        for (let i = 0; i < result.data.rows.length; i++) {
          let row = result.data.rows[i];
          row.items = this.utils.copy(row.mouldList);
          if (row.mouldList.length > 0) {
            this.$set(row, 'mould', row.mouldList[0]);
            //班制产量：根据“适配模具名称”的机模配信息，计算12小时产能：3600/标准周期 * 实际模腔数*12
            this.$set(row, 'shiftQuantity', 3600 / (row.mouldList[0].cycle / 1000).toFixed(1) * row.mouldList[0].actualCavity * 12);
          } else {
            this.$set(row, 'shiftQuantity', 0);
          }
        }
      }
      this.data = result.data.rows;
      console.log(result.data.rows);
      return result;
    },
    //创建生产计划前的数据处理
    beforeReq(params) {
      params.erpNo = params.scheNo;
      return params;
    },
    saveValidate() {
      this.http.get('/web/config/orderNumber/rule/page?type=23&enable=true').then(res => {
        if (res.data.total > 0) {
          if (this.yt.editObj.quantity == null || this.yt.editObj.quantity == undefined || this.yt.editObj.quantity == '') {
            this.utils.errorMessage(this.$t('jihuashuliang') + this.$t('bunengweikong'));
            return;
          } else if (this.yt.editObj.orgId == null || this.yt.editObj.orgId == undefined || this.yt.editObj.orgId == '') {
            this.utils.errorMessage(this.$t('guishuchejian') + this.$t('bunengweikong'));
            return;
          } else if (this.yt.editObj.startTime == null || this.yt.editObj.startTime == undefined || this.yt.editObj.endTime == null || this.yt.editObj.endTime == undefined) {
            this.utils.errorMessage(this.$t('jihuakaishi/wanchengshijian') + this.$t('bunengweikong'));
            return;
          } else {
            this.save();
          }
        } else {
          this.utils.errorMessage(this.$t('qingxianweihushengchanjihuadandedanhaoguize'));
          return;
        }
      }).catch(error => {
        this.utils.errorMessage(this.$t(error));
      });
    },
    save() {
      this.yt.editObj = this.beforeReq(this.yt.editObj);
      this.yt.editObj.loading = true;
      this.http.post('/web/production/plan/create', this.yt.editObj).then(result => {
        this.utils.successMessage(this.$t(result.msg));
        this.yt.get(null, this.beforeGet, this.afterGet);
        this.yt.isShowEditDialog = false;
      }).catch(error => {
        this.utils.errorMessage(this.$t(error));
      }).finally(() => {
        this.yt.editObj.loading = false;
      });
    },
    setDefaultValue1() {
      if (this.store.state.organizations.length > 0 && this.store.state.organizations[0].children.length > 0 && this.store.state.organizations[0].children[0].children.length > 0) {
        this.yt.editObj.orgId = this.store.state.organizations[0].children[0].children[0]['id'];
      }
    },
    dataFilter(query, row) {
      this.filterText = query;
      if (this.filterText != '') {
        // 存在筛选数组
        if (row.mouldList && row.mouldList.length > 0) {
          row.items = row.mouldList.filter(i => {
            // 添加多种条件来判断，即自定义搜索方式
            if (i.mould.name.indexOf(this.filterText) != -1 || i.mould.no.indexOf(this.filterText) != -1) {
              return true;
            }
          });
        }
      } else {
        // 不存在还原数组
        row.items = this.utils.copy(row.mouldList);
      }
      return true;
    },
    filter() {
      if (this.yt.conditions.materialCode && this.yt.conditions.materialName && this.yt.conditions.materialCode != '' && this.yt.conditions.materialName != '') {
        this.$refs.yt.list = this.data.filter(i => {
          if (i.material.code.indexOf(this.yt.conditions.materialCode) != -1 && i.material.name.indexOf(this.yt.conditions.materialName) != -1) {
            return true;
          }
        });
      } else if (this.yt.conditions.materialCode && this.yt.conditions.materialCode != '') {
        this.$refs.yt.list = this.data.filter(i => {
          if (i.material.code.indexOf(this.yt.conditions.materialCode) != -1) {
            return true;
          }
        });
      } else if (this.yt.conditions.materialName && this.yt.conditions.materialName != '') {
        this.$refs.yt.list = this.data.filter(i => {
          if (i.material.name.indexOf(this.yt.conditions.materialName) != -1) {
            return true;
          }
        });
      } else {
        this.$refs.yt.list = this.data;
      }
    },
    mouldChange(mould, row) {
      if (!mould) {
        return;
      }
      //班制产量：根据“适配模具名称”的机模配信息，计算12小时产能：3600/标准周期 * 实际模腔数*12
      row.shiftQuantity = 3600 / (row.mouldList[0].cycle / 1000).toFixed(1) * mould.actualCavity * 12;
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-input {
  width: 100%;
}
</style>